'use strict';

import {
    addFormControlSelect2,
    addSelectedCompanyHandler,
    companyGuard, fnErrorMsg, getSelectedCompany, setMissingVoucherText, toggleDisplaySelectClient,
    updateDataTableNewUrl
} from "./jquery-functions-library";
import {element_exists} from "./functions";

/**
 * Created by simonadams on 15/12/2016.
 */
export var fnEmployeeSettings = function () {

    if (!element_exists('#selected_company')) {
        return false;
    }
    toggleDisplayHelp();

    $('#selected_company').select2({
        width: '271px',
        height: '75%'
    }).addClass('form-control');

    $('#selected_company').off('select2:open').on('select2:open', function () {
        const parentsUntil = $('#select2-selected_company-results').parentsUntil($('span.select2-container'));
        parentsUntil.addClass('select-company-container');
        parentsUntil.parent().addClass('select2-top-container');

        parentsUntil.find($('input.select2-search__field')).prop('placeholder', allLangFiles.forms.search)
    });


    addFormControlSelect2();

    //Revert back to existing url when loading from here, as calls ajax twice from here. One dummy and one correct
    var revertBackToExistingUrl = true;

    $('#selected_company').off('select2:select');
    $('#selected_company').off('company-changed');

    $('#selected_company').on('select2:select', setSelectedCompany);
    addSelectedCompanyHandler(toggleDisplayHelp);
    addSelectedCompanyHandler(setClients);
};

function toggleDisplayHelp(e) {
    //TODO changed find selector, removed div.dataTables_scrollBody selector
    var table = $('#pjax-container').find('div.dataTables_scrollBody table.dataTable');

    var select = shouldSelect($('.payroll-options-col')) || shouldSelect($('.pay-slip-col'));

    if (shouldFilter(table) || select || $('#reportContainer').is(':visible')) {
        toggleDisplaySelectClient(companyGuard());
    }
    else {
        //$('#display-select-client').addClass('hidden');
    }
}

function setSelectedCompany(e) {

    if ($('#selected_company').attr('data-refresh')) {
        $('html').addClass('loading');
        $('#fakeloader').show();
        $('#pjax-container').hide();

    }

    $.ajax({
        type: 'GET',
        url: '/companies/selected/set/' + getSelectedCompany(),
        success: function (response) {

            let $selectedCompanyEl = $('#selected_company');
            $selectedCompanyEl.trigger('company-changed');
            if ($selectedCompanyEl.attr('data-refresh')) {
                window.location.reload();
                // $('html').removeClass('loading');

            }
        },
        global: false,
        error: fnErrorMsg
    })
}

function setClients(e) {

    var tables = $('#pjax-container').find('div.dataTables_scrollBody table.dataTable');
    var dt;

    var selectedCompanyId = getSelectedCompany();

    var select = shouldSelect($('.payroll-options-col')) || shouldSelect($('.pay-slip-col'));

    tables.each(function (index, item) {
        var table = $(item);

        if (shouldFilter(table) || select) {
            dt = table.DataTable();
            dt.draw();

            toggleDisplaySelectClient(companyGuard());
        } else {
            $('#display-select-client').addClass('hidden');

            if (table.attr('id') === 'datatable-users') {
                dt = table.DataTable();
                dt.draw();
            }

            if (table.attr('id') === 'datatable-vouchers-earlier-releases') {
                $('#form-vouchers-earlier-releases').trigger('submit');
            }
        }

        loadVouchers(table, selectedCompanyId);
        $('.table').resize();
    });
}

/*TODO use class name on elements instead */
function shouldFilter(table) {

    var filterThese = [
        'datatable-customer-employees',
        'datatable-vouchers'
    ];
    return filterThese.indexOf(table.attr('id')) !== -1 && table.is(':visible');
}

function loadVouchers(table, selectedCompanyId) {

    if (shouldReload(table)) {

        updateDataTableNewUrl(table, selectedCompanyId, function () {
            setMissingVoucherText();
        });

    }
}

/*TODO use class name on elements instead */
function shouldReload(table) {

    var reloadThese = ['datatable-vouchers'];

    return reloadThese.indexOf(table.attr('id')) !== -1/* && table.is(':visible')*/;
}

function shouldSelect(element) {
    return element.is(':visible');
}
